module.exports = __webpack_public_path__ + "assets/img/487d05a1634c9c319941d718db657bb4.svg";